import React from 'react';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import { bindActionCreators } from 'redux';
import flattenDeep from 'lodash/flattenDeep';
import uniq from 'lodash/uniq';
import compact from 'lodash/compact';
import StudentSteps from '../common/StudentSteps';
import * as runActions from '../../actions/runsActionCreators';
import * as courseActions from '../../actions/coursesActionCreators';
import * as studentActions from '../../actions/studentsActionCreators';
import * as commonActions from '../../actions/commonActions';
import Spinner from 'react-spinkit';
import { Badge, Row, Col, Table, OverlayTrigger, Tooltip } from 'react-bootstrap';
import CustomPagination from '../common/CustomPagination';
import { LocationColumn } from './LocationRow';
import DateRangePicker from '../common/DatePicker/DateRangePicker';
import moment from 'moment';
import CourseSlug from './CourseSlug'
import { getRequiredCreditsToProceed, getCurrentSelectionWeight, hasUnsavedChanges } from '../common/utils'
import { setCoursesToAdd } from '../../actions/general'

// ** NOTES Hey You!
// ** this file is a mess but here are some tips
// ** - state.courses is always the same as props.courses
// ** EXCEPT when you are searching, so.. theres that.
// ** hopefully I got to rewrite it and you'll never read this!

class FindClassesPage extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      coursesLoaded: false,
      courses: [],
      startCourses: 0,
      endCourses: 25,
      activeCoursePage: 1,
      expandedCourseId: null,

      slug: {
        up: false,
        down: false,
        idle: true
      },
      longname: {
        up: false,
        down: false,
        idle: true
      },
      instructor: {
        up: false,
        down: false,
        idle: true
      },
      weight: {
        up: false,
        down: false,
        idle: true
      },

      selected: true,
      preferences: []
    };

    this.setCoursesToState = this.setCoursesToState.bind(this);
    this.handleNext = this.handleNext.bind(this);
    this.handleCourseSearch = this.handleCourseSearch.bind(this);
    this.searchCourses = this.searchCourses.bind(this);
    this.checkKey = this.checkKey.bind(this);
    this.reorder = this.reorder.bind(this);
    this.sortByKeyAndDirection = this.sortByKeyAndDirection.bind(this);
    this.handleAddClass = this.handleAddClass.bind(this);
    this.handleRemoveClass = this.handleRemoveClass.bind(this);
    this.pageBack = this.pageBack.bind(this);
    this.pageForward = this.pageForward.bind(this);
  }

  componentDidMount() {
    // this whole function is MISSION CRITICAL and a mess
    // we need to refactor this
    // ** if we are loading fresh we don't have run data, so get it
    if (!this.props.run.id) this.props.runActions.getRun();

    // ** if we are loading fresh, we don't have a student, so get that too
    if (!this.props.student.id) {
      this.props.studentActions.getStudent().then(res => {
        if (res.target_course_units < 1) {
          browserHistory.push('/rank/' + localStorage.getItem('run') + '/start');
        }
      });
    }

    // **if we are loading fresh, we haven't set coursesToAdd yet
    // ** otherwise, courseToAdd will persist the data we are CURRENTLY working with
    if (!this.props.coursesToAdd.length) {
      this.props.courseActions.getAllCourses().then(() => {
        this.setCoursesToState(this.props.courses);
        if (!this.props.run.assignment_complete) {
          this.props.runActions.getAllRankPreferences().then(() => {
            const currentCourses = this.props.student.preferences.map(p => this.props.courses.find(c => c.id === p.course))
            this.props.setCoursesToAdd(currentCourses)
          });
        }
      });
    } else {
      this.setCoursesToState(this.props.courses);
    }

    document.onkeydown = this.checkKey;
  }


  getMinDateAndMaxDateOfClasses = () => {
    const { courses } = this.props;

    const courseMeetingDates = courses.reduce((prev, curr) => {
      const courseDates = curr.meetings.map((m) => ([m.startdate, m.enddate]));
      return [...prev, ...flattenDeep(courseDates)];
    }, []);

    courseMeetingDates.sort((a, b) => new Date(a) - new Date(b)); // sort metting dates asc.

    const meetingDates = compact(uniq(courseMeetingDates));

    return {
      minDate: meetingDates[0],
      maxDate: meetingDates[meetingDates.length - 1]
    };
  }


  setCoursesToState(courses) {
    this.setState({ courses: courses, coursesLoaded: true });
  }

  handleCourseSearch(e) {
    e.preventDefault();
    let term = e.target.value;
    if (term != '') {
      let arrUnique = this.searchCourses(term, this.props.courses);

      this.setState({
        courses: arrUnique,
        startCourses: 0,
        endCourses: 25,
        activeCoursePage: 1
      });
    } else {
      // this.props.courseActions.getAllCourses();
      this.setCoursesToState(this.props.courses);
    }
  }

  searchCourses(term, courses) {
    let b = courses.filter(course => {
      return (
        course.slug.toLowerCase().indexOf(term.toLowerCase()) != -1 ||
        course.longname.toLowerCase().indexOf(term.toLowerCase()) != -1 ||
        course.instructor.toLowerCase().indexOf(term.toLowerCase()) != -1 ||
        (course.description && course.description.toLowerCase().indexOf(term.toLowerCase()) != -1)
      );
    });
    return b;
  }

  handleNext() {
    browserHistory.push('/rank/' + localStorage.getItem('run') + '/rank');
  }

  checkKey(e) {
    if (this.refs.courses) {
      e = e || window.event;
      if (e.keyCode == '37') {
        // left arrow
        if (this.state.activeCoursePage > 1) {
          this.pageBack();
        }
      } else if (e.keyCode == '39') {
        // right arrow
        if (this.state.activeCoursePage < Math.ceil(this.state.courses.length / 25)) {
          this.pageForward();
        }
      }
    }
  }

  pageBack() {
    let newActivePage = this.state.activeCoursePage - 1;
    this.setState({ activeCoursePage: newActivePage });
    if (newActivePage == 1) {
      this.setState({ startCourses: 0, endCourses: 25 });
    } else {
      let start = newActivePage * 25 - 25;
      let end = newActivePage * 25;
      this.setState({ startCourses: start, endCourses: end });
    }
  }
  pageForward() {
    let newActivePage = this.state.activeCoursePage + 1;
    this.setState({ activeCoursePage: newActivePage });
    let start = newActivePage * 25 - 25;
    let end = newActivePage * 25;
    this.setState({ startCourses: start, endCourses: end });
  }

  // Ordering
  reorder(column) {
    if (this.state[column].idle) {
      this.setState({
        [column]: {
          up: true,
          down: false,
          idle: false
        }
      });
      let a = this.sortByKeyAndDirection(this.state.courses, column, 'up');
      this.setState({ courses: a });
    } else if (this.state[column].up) {
      this.setState({
        [column]: {
          up: false,
          down: true,
          idle: false
        }
      });
      let a = this.sortByKeyAndDirection(this.state.courses, column, 'down');
      this.setState({ courses: a });
    } else if (this.state[column].down) {
      this.setState({
        [column]: {
          up: true,
          down: false,
          idle: false
        }
      });
      let a = this.sortByKeyAndDirection(this.state.courses, column, 'up');
      this.setState({ courses: a });
    }
    let obj = {
      slug: {
        up: false,
        down: false,
        idle: true
      },
      longname: {
        up: false,
        down: false,
        idle: true
      },
      instructor: {
        up: false,
        down: false,
        idle: true
      },
      weight: {
        up: false,
        down: false,
        idle: true
      }
    };

    delete obj[column];
    this.setState(obj);

    // Reset pagination
    this.setState({
      startCourses: 0,
      endCourses: 25,
      activeCoursePage: 1
    });
  }

  sortByKeyAndDirection(array, key, direction) {
    return array.sort(function (a, b) {
      var x = a[key];
      var y = b[key];
      if (direction == 'up') {
        return x < y ? -1 : x > y ? 1 : 0;
      } else if (direction == 'down') {
        return x > y ? -1 : x < y ? 1 : 0;
      }
    });
  }

  addRemoveCourse(course) {
    let c = this.props.coursesToAdd.filter(c => {
      return c.id == course.id;
    });
    // let d = this.props.student.preferences.filter(d => {
    //   return d.course == course.id;
    // });

    const addClassComponent = (
      <span
        onClick={() => {
          this.handleAddClass(course);
        }}
      >
        Add
      </span>
    );

    const removeClassComponent = (
      <span
        onClick={() => {
          this.handleRemoveClass(course);
        }}
      >
        Remove
      </span>
    );

    // const removedCourse = localStorageCoursesMethods.getRemovedLocalCourse(course.id);

    // if (removedCourse) return addClassComponent;

    if (c[0]/* || d[0]*/) {
      return removeClassComponent;
    } else {
      return addClassComponent;
    }
  }

  handleAddClass(course) {
    this.props.setCoursesToAdd(this.props.coursesToAdd.concat([course]))
  }

  handleSelectRange = (from, to) => {
    const { courses } = this.props;

    if (from && to) {
      const firstDay = from;
      const lastDay = to;

      const filterCourses = courses.filter((c) => {
        const meetingDates = c.meetings.map((m) => ([m.startdate, m.enddate]));
        const filteredMeetingDates = compact(uniq(flattenDeep(meetingDates)));

        filteredMeetingDates.sort((a, b) => new Date(a) - new Date(b));

        const minDate = filteredMeetingDates[0];
        const maxDate = filteredMeetingDates[filteredMeetingDates.length - 1];

        if (
          moment(firstDay).isBetween(moment(minDate), moment(maxDate), null, '[]') ||
          moment(lastDay).isBetween(moment(minDate), moment(maxDate), null, '[]')
        ) {
          return true;
        }

        return false;
      });

      this.setState({
        courses: filterCourses,
        startCourses: 0,
        endCourses: 25,
        activeCoursePage: 1
      });

    } else {
      this.setCoursesToState(this.props.courses);
    }
  }

  handleRemoveClass(course) {
    const { coursesToAdd } = this.props;

    const courses = coursesToAdd.filter((item) => item.id !== course.id);
    this.props.setCoursesToAdd(courses);

    // const array = courses.map((item) => item.id);
    // localStorage.setItem('courses', array);

    // let preferences = this.props.student.preferences.slice();

    // preferences.map((item, index) => {
    //   if (item.course == course.id) {
    //     preferences.splice(index, 1);
    //     this.props.runActions.updatePreferencesState(preferences);
    //   }
    // });

    // localStorageCoursesMethods.setRemovedCourseToLocalStorage(course.id);
  }

  setActiveRow(course) {
    let c = this.props.coursesToAdd.filter(c => {
      return c.id == course.id;
    });

    if (c[0]/* || d[0]*/) {
      return 'active';
    } else {
      return null;
    }
  }


  mayRankTheSelection() {
    return getCurrentSelectionWeight(this.props.coursesToAdd) >= getRequiredCreditsToProceed(this.props.student.max_course_units)
  }

  renderDescription = (course, expandedCourseId) => {
    if (course.description && expandedCourseId === course.id) {
      return (
        <tr className="class-desc">
          <td colSpan="8">
            <p>{course.description}</p>
          </td>
        </tr>
      );
    }
    return null;
  };

  changeExpandedCourseId = id => {
    const expandedCourseId = this.state.expandedCourseId != id ? id : null;
    this.setState({ expandedCourseId });
  };

  renderInstructionText = () => (
    <Col md={7} className="mb-4">
      {this.props.run.additional_find_classes != null ? (
        <p className="lead" dangerouslySetInnerHTML={{
          __html: this.props.run.additional_find_classes
            .replace('[[[primary_contact_email]]]',
              `<a href="mailto:${this.props.run.primary_contact}">${this.props.run.primary_contact}</a>`)
        }}>
        </p>
      ) : (
        ''
      )}

    </Col>
  );

  renderNextButton = () => {
    const remainingCredits = getRequiredCreditsToProceed(this.props.student.max_course_units) - getCurrentSelectionWeight(this.props.coursesToAdd)
    const roundedRemainingCredits = Math.round(remainingCredits * 100) / 100
    return (
      <Col md={4}>
        <button
          type="button"
          className="pull-right btn btn-width-auto btn-primary"
          onClick={() => {
            this.handleNext();
          }}
          disabled={!this.mayRankTheSelection()}
        >
          {!this.mayRankTheSelection() ? `Add At Least ${roundedRemainingCredits} More ${roundedRemainingCredits < 2 ? 'Credit' : 'Credits'} to Continue` : 'Next: Rank Classes'}
        </button>
      </Col>
    )
  }

  renderPageSubtitle = () => (
    <Col md={8}>
      <div className="page-subtitle mt-0" style={{ marginBottom: '10' }}>Find classes</div>
    </Col>
  );

  renderSearchbar = () => (
    <Col md={9}>
      <div className="form-group search">
        <span className="fa fa-search" />
        <input
          name="conflictSearchInput"
          onChange={e => {
            this.handleCourseSearch(e);
          }}
          type="text"
          className="form-control search"
          placeholder="Type name, description or instructor..."
        />
        <span className="input-description">Type name, description or instructor to filter courses</span>
      </div>
    </Col>
  );

  renderWeekfilter = () => {
    const { minDate, maxDate } = this.getMinDateAndMaxDateOfClasses();

    return (
      <Col md={3}>
        <DateRangePicker
          handleSelectRange={this.handleSelectRange}
          inputLabel="Filter classes by date range"
          showClearButton
          inputClassNames="week-picker-auto-width"
          minDate={minDate}
          maxDate={maxDate}
        />
      </Col>
    )
  }

  render() {
    const { courses, startCourses, endCourses } = this.state;
    const tooltip1 = <Tooltip id="tooltip1">You cannot take this class</Tooltip>;
    const tooltip2 = <Tooltip id="tooltip2">You may be required to take this class</Tooltip>;
    const active_page_index = this.props.run.assignment_complete ? 2 : 1;

    return (
      <div>
        <Row className="mb-4">
          <Col md={12}>
            <StudentSteps
              active={active_page_index}
              isAssignmentCompleted={this.props.run.assignment_complete}
            />
            <Row>
              {this.renderPageSubtitle()}
              {this.renderNextButton()}
            </Row>
            <Row>
              <Col md={7} className="mb-4">
                {hasUnsavedChanges(this.props.student.preferences, this.props.coursesToAdd)
                  ? <Badge style={{ padding: '6px', backgroundColor: 'red' }}>Rankings not yet saved</Badge>
                  : null
                }
              </Col>
            </Row>
            <Row>
              {this.renderInstructionText()}
            </Row>
            <Row>
              {this.renderSearchbar()}
              {this.renderWeekfilter()}
            </Row>
          </Col>
        </Row>
        <Row ref="courses" className="height480">
          {this.state.coursesLoaded ? (
            <Col md={12}>
              {this.props.courses.length > 0 ? (
                <div className="c-table classes-table">
                  <Table condensed hover>
                    <thead>
                      <tr>
                        <th
                          className="name"
                          onClick={() => {
                            this.reorder('slug');
                          }}
                        >
                          <span>
                            Name {this.state.slug.up ? <i className="fa fa-sort-up" /> : null}
                            {this.state.slug.down ? <i className="fa fa-sort-down" /> : null}{' '}
                            {this.state.slug.idle ? <i className="fa fa-sort" /> : null}
                          </span>
                        </th>
                        <th
                          onClick={() => {
                            this.reorder('longname');
                          }}
                          className="max-width-300"
                        >
                          <span>
                            Description {this.state.longname.up ? <i className="fa fa-sort-up" /> : null}
                            {this.state.longname.down ? <i className="fa fa-sort-down" /> : null}{' '}
                            {this.state.longname.idle ? <i className="fa fa-sort" /> : null}
                          </span>
                        </th>
                        <th
                          onClick={() => {
                            this.reorder('instructor');
                          }}
                        >
                          <span>
                            Instructor {this.state.instructor.up ? <i className="fa fa-sort-up" /> : null}
                            {this.state.instructor.down ? <i className="fa fa-sort-down" /> : null}{' '}
                            {this.state.instructor.idle ? <i className="fa fa-sort" /> : null}
                          </span>
                        </th>
                        <th>Time</th>
                        <th
                          onClick={() => {
                            this.reorder('weight');
                          }}
                        >
                          <span>
                            Credits {this.state.weight.up ? <i className="fa fa-sort-up" /> : null}
                            {this.state.weight.down ? <i className="fa fa-sort-down" /> : null}{' '}
                            {this.state.weight.idle ? <i className="fa fa-sort" /> : null}
                          </span>
                        </th>
                        <th />
                        <th />
                      </tr>
                    </thead>
                    <tbody>
                      {courses
                        .filter((c) => !c.is_locked)
                        .slice(startCourses, endCourses)
                        .map((course, index) => {
                          return [
                            <tr key={index} className={`${this.setActiveRow(course)} increased-padding`}>
                              <td className="find-class-name"><CourseSlug course={course} /></td>
                              <td className="class-desc max-width-300">
                                {course.description ? <p>{course.longname}</p> : course.longname}
                                {course.description && (
                                  <button className="plain-button" onClick={() => this.changeExpandedCourseId(course.id)}>
                                    {this.state.expandedCourseId === course.id
                                      ? 'Extended Description [-]'
                                      : 'Extended Description [+]'}
                                  </button>
                                )}
                              </td>
                              <td className="class-desc">{course.instructor}</td>
                              <td className="class-desc">
                                <LocationColumn locations={commonActions.getCourseLocations(course)} />
                              </td>
                              <td className="class-desc">{course.weight}</td>
                              <td className="table-icon">
                                {course.is_locked ? (
                                  <OverlayTrigger placement="top" overlay={tooltip1}>
                                    <i className="fa fa-lock" />
                                  </OverlayTrigger>
                                ) : course.is_required ? (
                                  <OverlayTrigger placement="top" overlay={tooltip2}>
                                    <i className="fa fa-exclamation-circle" />
                                  </OverlayTrigger>
                                ) : null}
                              </td>
                              <td className="class-edit">{course.is_locked ? null : this.addRemoveCourse(course)}</td>
                            </tr>,
                            this.renderDescription(course, this.state.expandedCourseId)
                          ];
                        })}
                    </tbody>
                  </Table>
                  <CustomPagination
                    activePage={this.state.activeCoursePage}
                    onBack={this.pageBack}
                    onForward={this.pageForward}
                    listLength={Math.ceil(this.state.courses.filter((c) => !c.is_locked).length / 25)}
                  />
                </div>
              ) : (
                <div className="text-center">No Classes</div>
              )}
            </Col>
          ) : (
            <div className="spinner-box">
              <Spinner spinnerName="three-bounce" className="mt-4" />
            </div>
          )}
        </Row>
      </div>
    );
  }
}

FindClassesPage.propTypes = {
  //myProp: PropTypes.string.isRequired
};

function mapStateToProps(state) {
  return {
    run: state.run,
    student: state.student,
    courses: state.courses,
    coursesToAdd: state.general.coursesToAdd
  };
}

function mapDispatchToProps(dispatch) {
  return {
    runActions: bindActionCreators(runActions, dispatch),
    courseActions: bindActionCreators(courseActions, dispatch),
    studentActions: bindActionCreators(studentActions, dispatch),
    setCoursesToAdd: bindActionCreators(setCoursesToAdd, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(FindClassesPage);



// WEBPACK FOOTER //
// ./src/components/rank/FindClassesPage.js